"use strict";

var LoggerInstance = require("js-logger").get("ContactUsActions");

var ContactUsApi = require("../api/ContactUsApi");

var Spinner = require("../client/Spinner");

var AccountActions = require("../accountComponents/AccountActions");
var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var SmartyStreets = require("../accountComponents/SmartyStreets");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");

var ContactUsStore = require("../stores/ContactUsStore");

var ContactUsActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.CONTACT_US_INITIALIZE });
		Dispatcher.dispatch(action);

		// Initialize form data once page (and React components) have loaded.
		var that = this;
		document.addEventListener("DOMContentLoaded", function (event) {
			that.initializeAccountForm();
		});
	},

	initializeAccountForm() {
		if (ContactUsStore.get("isDesignMode")) {
			return;
		}

		var accountData = ContactUsStore.get("accountData");
		var contactUsData = JSON.parse(sessionStorage.getItem("contactusData"));
		if (contactUsData) {
			accountData = contactUsData;
			if (contactUsData.codes) {
				// Reset any demographics and set class is "isDirty" so the values are sent to SE after submit
				$(contactUsData.codes).each((index, codeElement) => {
					var $demographicList = $("[data-parent-form-component='accountDemographicsForm'][name='" + codeElement.type + "'][value='" + codeElement.value + "']");
					if ($demographicList && $demographicList.length == 1) {
						// We found the demographic by type and value => this is a radio or multi-select checkboxes
						if (codeElement.isDeleted) {
							$demographicList[0].checked = false;
						}
						else {
							$demographicList[0].checked = true;
						}
						$demographicList.addClass("isDirty");
					}
					else {
						var $demographicSingle = $("[data-parent-form-component='accountDemographicsForm'][name='" + codeElement.type + "']");
						if ($demographicSingle && $demographicSingle.length == 1) {
							if ($demographicSingle[0].type == "checkbox") {
								// Look up the parent div to find the checked/unchecked lookup
								var $parentDiv = $demographicSingle.closest("[data-component='singleCheckbox'][code-type='" + codeElement.type + "']");
								if ($parentDiv && $parentDiv.length == 1) {
									var checkedValue = $parentDiv[0].getAttribute("code-type-true-value")
									if (codeElement.value == checkedValue) {
										$demographicSingle[0].checked = true;
									}
									else {
										$demographicSingle[0].checked = false;
									}
								}
								$demographicSingle.addClass("isDirty");
							}
							if ($demographicSingle[0].type == "select-one") {
								// Find the option that was selected
								var options = Array.from($demographicSingle[0].options);
								var selectedOption = options.filter(option => {
									return option.value == codeElement.value;
								});
								if (selectedOption && selectedOption.length == 1) {
									$demographicSingle[0].selectedIndex = selectedOption[0].index;
									$demographicSingle.addClass("isDirty");
								}
							}
						}

					}
				});
			}
			sessionStorage.removeItem("contactusUrl");
			sessionStorage.removeItem("contactusData");
		}
		if (accountData) {
			var $accountForm = $("[data-component='contactUsForm'] [data-component='createAccountForm']");

			window.AccountActions.setSelectedTitle($accountForm.attr("id"), accountData.title);
			$accountForm.find("[data-component='accountFirstName']").val(accountData.firstName);
			$accountForm.find("[data-component='accountMiddleName']").val(accountData.middleName);
			$accountForm.find("[data-component='accountLastName']").val(accountData.lastName);
			$accountForm.find("[data-component='accountSuffix']").val(accountData.suffix);
			if (accountData.email) {
				$accountForm.find("[data-component='accountEmailAddress']").val(accountData.email.emailAddress);
			}
			if (accountData.address) {
				window.AccountActions.setSelectedCountry($accountForm.attr("id"), accountData.address.country);
				window.AccountActions.setSelectedState($accountForm.attr("id"), accountData.address.state);
				$accountForm.find("[data-component='accountAddressLine1']").val(accountData.address.line1);
				$accountForm.find("[data-component='accountAddressLine2']").val(accountData.address.line2);
				$accountForm.find("[data-component='accountAddressLine3']").val(accountData.address.line3);
				$accountForm.find("[data-component='accountAddressLine4']").val(accountData.address.line4);
				$accountForm.find("[data-component='accountAddressCity']").val(accountData.address.city);
				$accountForm.find("[data-component='accountAddressPostalCode']").val(accountData.address.postalCode);
			}
			if (accountData.phone) {
				$accountForm.find("[data-component='accountPhoneAreaCode']").val(accountData.phone.areaCode);
				$accountForm.find("[data-component='accountPhoneNumber']").val(accountData.phone.phoneNumber);
			}
			if (contactUsData && contactUsData.formType) {
				$("[name='communication.type']").val(contactUsData.formType);
			}
			if (contactUsData && contactUsData.comment) {
				$("[data-component='contactUsForm.comment']").val(contactUsData.comment);
			}
			if (contactUsData && contactUsData.summary) {
				$("[data-component='contactUsForm.summary']").val(contactUsData.summary);
			}

			//This will also trigger the media filtering after the address is set.
			window.AccountActions.setSelectedMediaOutlet(accountData.mediaOutlet);
		}
	},

	submitContactUsRequest(event) {
		if (!event || !event.target) {
			return false;
		}

		var $form = $(event.target);

		try {
			if (ContactUsStore.get("isDesignMode")) {
				event.preventDefault();
				event.stopPropagation();

				return;
			}

			var components = [
				$("[data-component='accountDemographicsForm']"),
				$("[data-component='accountMediaForm']"),
				$(event.target).closest("[data-component='contactUsForm']")
			];

			Spinner.showSpinner();
			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				SmartyStreets.verifyAddress("createAccountForm").done(() => {
					AccountFormHelper.serializeDataNecessaryToCreateAnAccount({
						selector: `[data-component="${$form.attr("data-child-of")}"]`,
						selectorFunction: "first", // Passing the jQuery extention method ".first()" as a string
						shouldEncodePassword: false //ContactUs form will never have a password input
					}).always(accountData => {
						// Parse contact us form
						var formType = this._getFormValueOrDefault("contactUsForm", "[data-component='communicationType'] select", "data-default-communication-type");
						var summary = this._getFormValueOrDefault("contactUsForm", "[data-component='contactUsForm.summary']", "data-default-summary");
						var comment = $("[data-component='contactUsForm.comment']").val();

						// Combine account and communication information
						var allowUpdate = $("[data-component='contactUsForm'] [data-component='createAccountForm']").is("[data-update-allowed]");

						var submissionData = Object.assign({}, accountData, {
							formType,
							summary,
							comment,
							allowUpdate
						});

						ContactUsApi.submitContactUsRequest(submissionData).done(() => {
							SubmitButtonHelper.performPostSubmitAction("[data-component='contactUsForm']");
						}).fail((jqXHR) => {
							if (jqXHR.responseText.includes("User not signed in.")) {
								// Redirect to login page
								sessionStorage.setItem("contactusUrl", window.location.pathname.substring(1));
								sessionStorage.setItem("contactusData", JSON.stringify(submissionData));
								window.location.href = "login";
							}
							else {
								ApiHelper.displayErrorMessage(jqXHR);
							}
						}).always(() => Spinner.removeSpinner());
					});
				}).fail(() => Spinner.removeSpinner());
			});
		} catch (exception) {
			LoggerInstance.error(exception);
			Spinner.removeSpinner();
		} finally {
			return false;
		}
	},

	_getFormValueOrDefault(parentComponent, componentSelector, attributeName) {
		var formValue = $(`[data-component="${parentComponent}"]`).find(componentSelector).val();

		if (!formValue) {
			var $component = $(`[data-component="${parentComponent}"]`);
			formValue = $component.attr(attributeName);
		}

		return formValue;
	},
};

module.exports = ContactUsActions;


// WEBPACK FOOTER //
// ./Javascript/actions/ContactUsActions.jsx